"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateItemApiUrl = void 0;
const generateItemApiUrl = (eventType, itemId, rev) => {
    // Determine url based on item type
    let url;
    if (eventType === "EVENEMENT") {
        url = `/events/${itemId}`;
    }
    else {
        url = `/locations/${itemId}`;
    }
    if (rev) {
        url += `?_rev=${rev}`;
    }
    return url;
};
exports.generateItemApiUrl = generateItemApiUrl;
//# sourceMappingURL=generateItemApiUrl.js.map